'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var parallelBatch = require('it-parallel-batch');

var mergeOptions = require('merge-options').bind({
  ignoreUndefined: true
});

var defaultOptions = {
  chunker: 'fixed',
  strategy: 'balanced',
  // 'flat', 'trickle'
  rawLeaves: false,
  onlyHash: false,
  reduceSingleLeafToSelf: true,
  codec: 'dag-pb',
  hashAlg: 'sha2-256',
  leafType: 'file',
  // 'raw'
  cidVersion: 0,
  progress: function progress() {
    return function () {};
  },
  shardSplitThreshold: 1000,
  fileImportConcurrency: 50,
  blockWriteConcurrency: 10,
  minChunkSize: 262144,
  maxChunkSize: 262144,
  avgChunkSize: 262144,
  window: 16,
  polynomial: 17437180132763653,
  // https://github.com/ipfs/go-ipfs-chunker/blob/d0125832512163708c0804a3cda060e21acddae4/rabin.go#L11
  maxChildrenPerNode: 174,
  layerRepeat: 4,
  wrapWithDirectory: false,
  pin: false,
  recursive: false,
  hidden: false,
  preload: false,
  chunkValidator: null,
  importBuffer: null
};

module.exports = /*#__PURE__*/function () {
  var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source, block) {
    var options,
        opts,
        dagBuilder,
        treeBuilder,
        _iteratorNormalCompletion,
        _didIteratorError,
        _iteratorError,
        _iterator,
        _step,
        _value,
        entry,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
            opts = mergeOptions(defaultOptions, options);

            if (options.cidVersion > 0 && options.rawLeaves === undefined) {
              // if the cid version is 1 or above, use raw leaves as this is
              // what go does.
              opts.rawLeaves = true;
            }

            if (options.hashAlg !== undefined && options.rawLeaves === undefined) {
              // if a non-default hash alg has been specified, use raw leaves as this is
              // what go does.
              opts.rawLeaves = true;
            } // go-ifps trickle dag defaults to unixfs raw leaves, balanced dag defaults to file leaves


            if (options.strategy === 'trickle') {
              opts.leafType = 'raw';
              opts.reduceSingleLeafToSelf = false;
            }

            if (options.format) {
              opts.codec = options.format;
            }

            if (typeof options.dagBuilder === 'function') {
              dagBuilder = options.dagBuilder;
            } else {
              dagBuilder = require('./dag-builder');
            }

            if (typeof options.treeBuilder === 'function') {
              treeBuilder = options.treeBuilder;
            } else {
              treeBuilder = require('./tree-builder');
            }

            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context.prev = 10;
            _iterator = _asyncIterator(treeBuilder(parallelBatch(dagBuilder(source, block, opts), opts.fileImportConcurrency), block, opts));

          case 12:
            _context.next = 14;
            return _awaitAsyncGenerator(_iterator.next());

          case 14:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 18;
            return _awaitAsyncGenerator(_step.value);

          case 18:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 26;
              break;
            }

            entry = _value;
            _context.next = 23;
            return {
              cid: entry.cid,
              path: entry.path,
              unixfs: entry.unixfs,
              size: entry.size
            };

          case 23:
            _iteratorNormalCompletion = true;
            _context.next = 12;
            break;

          case 26:
            _context.next = 32;
            break;

          case 28:
            _context.prev = 28;
            _context.t0 = _context["catch"](10);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 32:
            _context.prev = 32;
            _context.prev = 33;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context.next = 37;
              break;
            }

            _context.next = 37;
            return _awaitAsyncGenerator(_iterator.return());

          case 37:
            _context.prev = 37;

            if (!_didIteratorError) {
              _context.next = 40;
              break;
            }

            throw _iteratorError;

          case 40:
            return _context.finish(37);

          case 41:
            return _context.finish(32);

          case 42:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[10, 28, 32, 42], [33,, 37, 41]]);
  }));

  return function (_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();